import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    window.cookieConsentController = this // ✅ make controller available globally
    const consent = localStorage.getItem("cookie_consent")
    if (!consent) this.bannerTarget.classList.remove("hidden")
    if (consent === "accepted") document.dispatchEvent(new Event("cookie:accepted"))
  }

  accept() {
    localStorage.setItem("cookie_consent", "accepted")
    this.bannerTarget.classList.add("hidden")
    document.dispatchEvent(new Event("cookie:accepted"))
  }

  decline() {
    localStorage.setItem("cookie_consent", "declined")
    this.bannerTarget.classList.add("hidden")
  }

  showBanner() {
    this.bannerTarget.classList.remove("hidden")
  }
}
